import { render, staticRenderFns } from "./api.vue?vue&type=template&id=0ff45cae&scoped=true"
import script from "./api.vue?vue&type=script&lang=js"
export * from "./api.vue?vue&type=script&lang=js"
import style0 from "./api.vue?vue&type=style&index=0&id=0ff45cae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff45cae",
  null
  
)

export default component.exports